import script from "./CompanyDashboard.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompanyDashboard.vue?vue&type=script&setup=true&lang=ts"

import "./CompanyDashboard.vue?vue&type=style&index=0&id=6252df1a&lang=postcss&scoped=true"

import exportComponent from "/home/runner/work/matchd-frontend/matchd-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6252df1a"]])

export default __exports__